import React from "react";
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import languages from "../collections/languages"
import srLatin from "date-fns/locale/sr-Latn"
import {formatDate} from "../scripts/validation"
import {connect} from "react-redux";
import {setStartDate , setEndDate} from "../redux/actions";

class DatepickerComponent extends React.Component {
    constructor(props) {
        super ( props );
        let date = new Date ();
        date.setDate ( date.getDate () + 1 );
        let enddate = new Date ();
        enddate.setDate ( enddate.getDate () + 1 );
        enddate.setFullYear ( enddate.getFullYear () + 1 );
        let x = formatDate ( enddate );
        this.setState ( { endDate : enddate } );
        this.props.setEndDate (
            { endDate : x }
        );
        this.state = {
            startDate : date ,
            endDate : enddate ,
            minDate : date ,
        };


    }

    handleDateChangeStart = (m) => {
        let date = formatDate ( m );
        this.setState ( { startDate : m } );
        if (m>this.state.endDate) {
            this.setState ( { endDate : m } );
            this.props.setEndDate (
                { endDate : date }
            );
        }
        this.props.setStartDate (
            { startDate : date }
        );
        this.handleDateChangeEnd ( m )
    };
    handleDateChangeEnd = (m) => {
        let date = new Date ( m );
        var year = date.getFullYear ();
        var month = date.getMonth ();
        var day = date.getDate ();
        var c = new Date ( year + 1 , month , day );
        let x = formatDate ( c );
        this.setState ( { endDate : c } );
        this.props.setEndDate (
            { endDate : x }
        );
    };

    render() {

        const PickBtn = ({ value , onClick }) => (
            <div className={"flex"} onClick={onClick}>
                <button className="button-picker">
                    {value}
                </button>
                <img src={require ( "../images/calendar-30.png" )} alt={"..."}/>
            </div>
        );
        return (

            <div className={"flex-around grow1 w-100 input-group"}>
                <div className={"flex-center datepicker"}>
                    <div
                        className={"margin-h-20"}>{!languages[this.props.lang] ? " " : languages[this.props.lang].datepickerStart}</div>
                    <DatePicker
                        locale={languages[this.props.lang] === "en" ? "en" : srLatin}
                        selected={this.state.startDate}
                        onChange={this.handleDateChangeStart}
                        dateFormat="dd. MMMM yyyy."
                        //selectsEnd
                        startDate={this.state.startDate}
                        minDate={this.state.minDate}
                        customInput={<PickBtn/>}
                        withPortal
                    />
                </div>
                <div className={"flex-center datepicker"}>
                    <div
                        className={"margin-h-20"}>{!languages[this.props.lang] ? " " : languages[this.props.lang].datepickerEnd} </div>
                    <DatePicker
                        locale={languages[this.props.lang] === "en" ? "en" : srLatin}
                        selected={this.state.endDate}
                        onChange={this.handleDateChangeEnd}
                        disabled
                        dateFormat="dd. MMMM yyyy."
                        //selectsEnd
                        startDate={this.state.endDate}
                        minDate={this.state.endDate}
                        customInput={<PickBtn/>}
                        withPortal
                        readOnly
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
    });
};

const mapDispatchToProps = (dispatch) => {
    return ({
        setStartDate : (params) => {
            dispatch ( setStartDate ( params ) );
        } , setEndDate : (params) => {
            dispatch ( setEndDate ( params ) );
        } ,
    })
};

export const Datepicker = connect ( mapStateToProps , mapDispatchToProps ) ( DatepickerComponent );